import { useState } from "react";
import SectionTitle from "../../components/SectionTitle";
// import SingleService from "../../components/Service/SingleService";
// import serviceImg1 from "../../assets/images/about/who-1.png";
// import serviceImg2 from "../../assets/images/about/who-2.png";
// import serviceImg3 from "../../assets/images/about/who-3.png";
// import serviceImg4 from "../../assets/images/about/who-4.png";
import CountUp from "react-countup";
import ReactVisibilitySensor from "react-visibility-sensor";

const data = [
  { figures: "100000", subtitle: "Candidates Trained", color: "#FFEDC6" },
  {
    figures: "60000",
    subtitle: "Candidates Successfully Placed",
    color: "#EDFEF1",
  },
  { figures: "25", subtitle: "States Penetrated", color: "#FFEDF5" },
  { title: "100000", subtitle: "Operating Centers", color: "#E4FDFF" },
  { title: "24", subtitle: "Industry Specific Courses", color: "#F6E5FF" },
];

const TransformingFuture = ({ data }) => {
  const [state, setState] = useState(true);

  return (
    <div className="react_popular_topics  pb---70">
      <div className="container">
        <SectionTitle Title="Ocfit" subtitle="Transforming Future" />
        <div className="d-flex flex-wrap gap-3 justify-content-evenly align-items-center text-center">
          {data?.map((item, idx) => (
            <div
              key={idx}
              className="wow animate__fadeInUp"
              data-wow-duration="0.3s"
            >
              <div
                style={{
                  backgroundColor:
                    idx === 0
                      ? "#FFEDC6"
                      : idx === 1
                      ? "#EDFEF1"
                      : idx === 2
                      ? "#FFEDF5"
                      : idx === 3
                      ? "#E4FDFF"
                      : idx === 4
                      ? "#F6E5FF"
                      : "#E4FDFF", // Added missing `#` in the default value
                }}
                className="p-3 transforming_future text-white rounded-circle d-flex flex-column justify-content-center align-items-center"
              >
                <h2 className="mb-2">
                  <CountUp
                    start={state ? 0 : Number(item.figure)}
                    end={Number(item.figure)}
                    duration={10}
                    onEnd={() => setState(false)}
                  />
                  {({ countUpRef, start }) => (
                    <ReactVisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </ReactVisibilitySensor>
                  )}+
                </h2>
                <strong className="text-black">{item?.title}</strong>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransformingFuture;
